import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Paper,
    page,
    TablePagination
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {

        const routeSummaryData = this.props.routeSummaryData;
        const routeSummaryTotal = this.props.routeSummaryTotal;
        const searchData = this.props.searchData;

        return (
            <div>

                <h2><center><u>Route Summary</u></center></h2>
                <div>&nbsp;</div>
                <h2><center>{searchData.factoryName} - {searchData.groupName}</center></h2>
                <div>&nbsp;</div>
                <h3><center>{searchData.date} </center></h3>
                <div>
                    <Box minWidth={1050}>
                        {routeSummaryData.length > 0 ?
                            <Table aria-label="caption table" style={{border:'1px solid #ccc', width:'99%', margin:'auto'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'left'} style={{ borderTop: '1px solid #ccc' }}>Route</TableCell>
                                        <TableCell align={'left'} style={{ borderTop: '1px solid #ccc' }}>Route Code</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Registred</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Dealers</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Small</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Estates</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Active Last Month</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Target</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Last Month</TableCell>
                                        <TableCell align={'center'} style={{ borderTop: '1px solid #ccc' }}>Last 3 Month Avg</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {routeSummaryData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.routeCode}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.registered}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.dealer}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.supplier}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.estate}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.customerCountForLastMonth}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {parseInt(data.targetCrop).toLocaleString('en-US')}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.cropAmountForLastMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.lastThreeMonthAvg.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow>
                                    <TableCell align={'left'} style={{ borderTop: '1px solid #ccc' }}><b>Total</b></TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.registered} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.dealer} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.supplier} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.estate} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.customerCountForLastMonth} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.targetCrop.toLocaleString('en-US')} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.cropAmountForLastMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ borderTop: '1px solid #ccc' }}>
                                        <b> {routeSummaryTotal.lastThreeMonthAvg.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                                    </TableCell>
                                </TableRow>
                            </Table> : null}
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}